// extracted by mini-css-extract-plugin
export default {"bar":"EvalBar_bar__UyTsH","barBlack":"EvalBar_barBlack__eg64q","barWhite":"EvalBar_barWhite__cCNJq"};